/**
 * The FEMA ICS 206 authoring card.
 *
 * Boxes 3 to 5 are the aid station, transportation, and hospital tables, each
 * owned by its own entity and saving itself. Box 6 is the only narrative box,
 * so it is the only one in the card-level save. The card's contribution is the
 * printed numbering and titles, which the tables did not carry before.
 */

import type React from 'react';
import type { ReactNode } from 'react';

import { HospitalsTable } from '../planningView/widgets/MedicalPlan/HospitalsTable';
import { MedicalAidStationsTable } from '../planningView/widgets/MedicalPlan/MedicalAidStationsTable';
import { TransportationsTable } from '../planningView/widgets/MedicalPlan/TransportationsTable';

import FemaIncidentInfoCard from './FemaIncidentInfoCard';

export type Fema206CardProps = {
  disabled?: boolean;
  banner?: ReactNode;
  headerActions?: ReactNode;
};

export const Fema206Card: React.FC<Fema206CardProps> = ({
  disabled = false,
  banner,
  headerActions,
}) => (
  <FemaIncidentInfoCard
    baseId="ICS_206"
    banner={banner}
    headerActions={headerActions}
    slots={{
      aidStations: <MedicalAidStationsTable readOnly={disabled} />,
      ambulanceServices: <TransportationsTable readOnly={disabled} />,
      hospitals: <HospitalsTable readOnly={disabled} />,
    }}
  />
);

export default Fema206Card;
